import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { toDataURL } from 'mm-ui';
import { Utils } from 'projects/f-cms/src/app/utils/utils';
import { MediaService } from '../../../../media/media.service';
import { mseStreamingSupported } from '../../../../media/mse-streaming-supported';
import * as uuid from 'uuid';
import { AliceService } from '../../../../alice/alice.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit, OnChanges, OnDestroy {
  id: string;
  media: any;
  border: any;
  autoplay: any;
  controls: any;
  controlsList: any;
  oncontextmenu: any;
  loop: any;
  noaudio: any;
  urlPoster: any;
  mediaType: string;
  alt: string;
  mediaPicker: any;
  spreadSheetImage: boolean = false;
  align: string;
  mediaId: string

  @ViewChild('resource', { static: true }) resource: ElementRef;
  @ViewChild('resourceVideo', { static: true }) resourceVideo: ElementRef;
  @Input('data-media') mediaData: any;
  @Input('autoStart') autoStart: any;
  @Input('timestamp') timestamp: any;
  @Input('page') page: any;
  @Input('urlThumbnail') urlThumbnail: string;
  @Input('thumbnailMediaId') thumbnailMediaId: string;
  @Output('update') update = new EventEmitter();
  dialogType: any;
  width: any;
  height: any;
  linkTo: any;
  mdSrvc: string;
  mediaInfo: any;
  iTk: any;
  start: boolean;
  src: string;
  error: boolean = false;
  urlPosterFromCDN = false;
  loading = false;
  identifier = uuid.v4();

  private destroyed = false;
  private readonly subs = new Subscription();
  private mseDispose: (() => void) | null = null;


  constructor(
    private elementRef: ElementRef,
    private mediaService: MediaService,
    private sanitizer: DomSanitizer,
    private utils: Utils,
    private aliceService: AliceService
  ) { }

  ngOnInit() {

    if (this.utils.hasStorage('mdService')) {
      this.mdSrvc = this.utils.getStorage('mdService')
    }
    this.subs.add(this.mediaService.getIamToken().subscribe(itk => {
      if (this.destroyed) {
        return;
      }
      this.iTk = itk;

      if (this.mediaData && this.mediaData.mediaInfo) {
        this.mediaInfo = this.mediaData.mediaInfo;
      }

    }));

    this.getMedia();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.stopPlayback();
    this.subs.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.getMedia();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.timestamp && !!changes.timestamp.currentValue) {
      const waitForPlayer = () => {
        if (this.destroyed) {
          return;
        }
        let prefix = '_'

        if (this.media?.content_type?.indexOf('video') >= 0) {
          prefix = "video_";
        }

        if (this.media?.content_type?.indexOf('audio') >= 0) {
          prefix = "audio_";
        }

        const mediaId = this.media?.id || this.id;
        const player: any = document.getElementById(prefix + mediaId + '_' + this.identifier);
        if (player) {
          player.currentTime = this.convertTimestampToSeconds(this.timestamp);

          setTimeout(() => {
            if (this.destroyed) {
              return;
            }
            player.play();
            this.update.emit({ type: 'scroll', player });
          }, 100);
        } else {
          setTimeout(() => waitForPlayer(), 100);
        }
      }

      waitForPlayer();
    }
  }

  convertTimestampToSeconds(timestamp: string) {
    const [minutes, seconds] = timestamp?.split(":") || [0, 0];

    return +minutes * 60 + +seconds;
  }


  getMedia() {
    this.spreadSheetImage = this.elementRef.nativeElement.dataset.spreadsheetimage
    this.id = this.mediaInfo && this.mediaInfo.id ? this.mediaInfo.id : this.elementRef.nativeElement.id;
    this.mediaId = this.mediaInfo && this.mediaInfo.mediaId ? this.mediaInfo.mediaId : null;
    this.alt = this.mediaInfo && this.mediaInfo.alt ? this.mediaInfo.alt : this.elementRef.nativeElement.alt;
    this.mediaPicker = this.mediaInfo && this.mediaInfo.mediaPicker ? this.mediaInfo.mediaPicker : this.elementRef.nativeElement.dataset ? this.elementRef.nativeElement.dataset.mediapicker : true;
    this.border = this.mediaInfo && this.mediaInfo.border ? this.mediaInfo.border : this.elementRef.nativeElement && this.elementRef.nativeElement.dataset ? this.elementRef.nativeElement.dataset.border : '';
    this.height = this.mediaInfo && this.mediaInfo.height ? this.mediaInfo.height : this.elementRef.nativeElement && this.elementRef.nativeElement.dataset ? this.elementRef.nativeElement.dataset.height : '';
    this.width = this.mediaInfo && this.mediaInfo.width ? this.mediaInfo.width : this.elementRef.nativeElement && this.elementRef.nativeElement.dataset ? this.elementRef.nativeElement.dataset.width : '';
    this.dialogType = this.mediaInfo && this.mediaInfo.dialogType ? this.mediaInfo.dialogType : this.elementRef.nativeElement.dataset ? (this.elementRef.nativeElement.dataset.type ? this.elementRef.nativeElement.dataset.type : false) : false;
    this.linkTo = this.mediaInfo && this.mediaInfo.linkTo ? this.mediaInfo.linkTo : this.elementRef.nativeElement.dataset ? (this.elementRef.nativeElement.dataset.link != null && this.elementRef.nativeElement.dataset.link != 'undefined' && this.elementRef.nativeElement.dataset.link != 'null' ? this.elementRef.nativeElement.dataset.link : false) : false;
    this.controlsList = this.mediaInfo && this.mediaInfo.nodownload ? 'nodownload' : this.elementRef.nativeElement.dataset && this.elementRef.nativeElement.dataset.nodownload ? 'nodownload' : 'download';
    this.oncontextmenu = this.mediaInfo && this.mediaInfo.oncontextmenu ? this.mediaInfo.oncontextmenu : this.elementRef.nativeElement.dataset && this.elementRef.nativeElement.dataset.oncontextmenu ? this.elementRef.nativeElement.dataset.oncontextmenu : 'return true';
    this.align = this.mediaInfo && this.mediaInfo.align ? this.mediaInfo.align : '';
    this.noaudio = this.mediaInfo && this.mediaInfo.noaudio ? this.mediaInfo.noaudio : this.elementRef.nativeElement.dataset ? (this.elementRef.nativeElement.dataset.noaudio != null && this.elementRef.nativeElement.dataset.noaudio != 'undefined' && this.elementRef.nativeElement.dataset.noaudio != 'null' ? this.elementRef.nativeElement.dataset.noaudio : false) : false;
    this.loop = this.mediaInfo && this.mediaInfo.loop ? this.mediaInfo.loop : this.elementRef.nativeElement.dataset ? (this.elementRef.nativeElement.dataset.loop != null && this.elementRef.nativeElement.dataset.loop != 'undefined' && this.elementRef.nativeElement.dataset.loop != 'null' ? this.elementRef.nativeElement.dataset.loop : false) : false;
    this.urlPoster = this.mediaInfo && this.mediaInfo.urlPoster ? this.mediaInfo.urlPoster : '';

    // Se temos urlThumbnail do input, usar como urlPoster
    if (this.urlThumbnail) {
      this.urlPoster = this.urlThumbnail;
    } // else if (this.thumbnailMediaId && !this.urlPoster) {
    //   // Se temos thumbnailMediaId mas não urlPoster, usar o mediaId como poster
    //   this.urlPoster = this.thumbnailMediaId;
    // }

    if (this.urlPoster && (this.urlPoster.indexOf('://cdn.') >= 0 || this.urlPoster.indexOf('://storage-mmp5privatebucket') >= 0)) {
      this.urlPosterFromCDN = true;
    }

    if (this.linkTo && this.linkTo.indexOf('://cdn.') >= 0) {
      this.subs.add(this.mediaService.getCDNImage(this.linkTo, this.iTk).subscribe((binarie: any) => {
        if (this.destroyed) {
          return;
        }

        let file = toDataURL(binarie);

        if (file) {

          file.then((data: any) => {
            if (this.destroyed) {
              return;
            }

            const blob = this.convertBase64ToBlob(data.result);
            const blobUrl = URL.createObjectURL(blob);
            this.linkTo = this.sanitizer.bypassSecurityTrustUrl(blobUrl);


          });
        };
      }));
    }

    this.checkMediaPickerAndElement();

    if (this.mediaId) {
      this.aliceService.addCurrentMedias(this.mediaId);
    }
  }

  checkMediaPickerAndElement() {
    if (!this.mediaPicker && this.dialogType) {
      let content_type = this.dialogType == 'video' ? `${this.dialogType}/${this.id.split('.').reverse()[0]}` : (this.dialogType == 'audio' ? `${this.dialogType}/mpeg` : this.dialogType);

      this.createMediaElement({
        resource_file: {
          content_type,
          is_image: this.dialogType == 'image',
          url: this.mediaId ? this.mediaId : this.id
        }
      })
    } else {
      let id = this.mediaId ? this.mediaId : this.id;
      if (id) {
        this.subs.add(this.mediaService.getMediaById(id).subscribe(media => {
          if (this.destroyed) {
            return;
          }
          this.subs.add(this.mediaService.getMedia(id).subscribe((res: any) => {
            if (this.destroyed) {
              return;
            }
            media.resource_file = { ...media.resource_file, ...res }
            this.createMediaElement(media)
          }))
        }));
      }
    }
  }

  convertBase64ToBlob(base64Image: string) {
    const parts = base64Image.split(';base64,');
    const imageType = parts[0].split(':')[1];
    const decodedData = window.atob(parts[1]);
    // so deus sabe pq tava quebrando quando baixa esse mimetype
    const uInt8Array = new Uint8Array(imageType === 'application/vnd.ms-excel.sheet.macroenabled.12' ? decodedData.length - 1 : decodedData.length);

    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    };

    return new Blob([uInt8Array], { type: imageType });
  };

  openMedia(url) {

    this.subs.add(this.mediaService.getCDNImage(url, this.iTk).subscribe((binarie: any) => {
      if (this.destroyed) {
        return;
      }

      let file = toDataURL(binarie);

      if (file) {

        file.then((data: any) => {
          if (this.destroyed) {
            return;
          }

          const blob = this.convertBase64ToBlob(data.result);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        });
      };

    }))
  }


  createMediaElement(media: any): void {
    if (this.destroyed) {
      return;
    }
    this.media = media.resource_file
    this.mediaType = this.media && this.media.content_type.indexOf('audio') >= 0 ? 'audio' : this.media && this.media.content_type.indexOf('video') >= 0 ? 'video' : 'image';

    if (this.autoStart && (this.mediaType === 'audio' || this.mediaType === 'video')) {
      this.update.emit(true);
      this.startMedia(this.mediaType, this.media);
    }
  }

  private fullMediaFallbackStarted = false;

  startMedia(type, media) {
    if (this.destroyed || (this.loading && !this.src)) {
      return;
    }

    const thePlayer = this.getPlayerElement(type, media);

    if (this.start && this.src && thePlayer) {
      this.playMediaElement(thePlayer);
      return;
    }

    this.loading = true;
    this.fullMediaFallbackStarted = false;
    this.mseDispose?.();
    this.mseDispose = null;

    if (thePlayer && type === 'video') {
      const videoPlayer = thePlayer as HTMLVideoElement;
      videoPlayer.setAttribute('playsinline', '');
      videoPlayer.setAttribute('webkit-playsinline', '');
      videoPlayer.playsInline = true;
      this._attachVideoTracking(videoPlayer, media);
    }

    const useMse =
      type === 'video' &&
      !!thePlayer &&
      !media?.fragmentationFailed &&
      mseStreamingSupported(media?.mimeCodec);

    if (useMse) {
      this.start = true;
      this.loading = false;
      this.update.emit(true);

      let seconds = 0;

      if (this.timestamp) {
        seconds = this.convertTimestampToSeconds(this.timestamp);
      }

      try {
        this.mseDispose = this.mediaService.getCDNVIdeo(media, this.page, this.iTk, thePlayer, seconds, (currentTime, reason) => {
          if (this.destroyed || this.fullMediaFallbackStarted) {
            return;
          }
          this.fullMediaFallbackStarted = true;
          if (reason && !media?.fragmentationFailed) {
            this.mediaService.requestRefragment(media.id, reason).subscribe({
              next: (res) => console.log('[refragment]', res),
              error: (err) => console.warn('[refragment] failed', err),
            });
          }
          this.loadFullMedia(media, thePlayer, currentTime);
        });
      } catch (_) {
        this.loadFullMedia(media, thePlayer, seconds);
      }
      return;
    }

    this.loadFullMedia(media, thePlayer);
  }

  private getPlayerElement(type: string, media: any): HTMLMediaElement | null {
    const mediaId = media?.id || this.media?.id || this.id;
    if (!mediaId) {
      return null;
    }

    const prefix = type === 'video' ? 'video_' : 'audio_';
    return document.getElementById(prefix + mediaId + '_' + this.identifier) as HTMLMediaElement | null;
  }

  private playMediaElement(player: HTMLMediaElement, currentTime?: number): void {
    if (currentTime) {
      player.currentTime = currentTime;
    }

    const playPromise = player.play();
    if (playPromise?.catch) {
      playPromise.catch(() => {});
    }
  }

  private _attachVideoTracking(player: HTMLVideoElement, media: any) {
    const playTimestamp = new Date().toISOString();
    const checkpoints = new Set<number>();
    let sent = false;

    player.addEventListener('timeupdate', () => {
      checkpoints.add(Math.floor(player.currentTime));
    });

    const send = () => {
      if (sent || checkpoints.size <= 0) return;
      sent = true;
      const pageId = this.page?.id ?? localStorage.getItem('pageId') ?? null;
      const homePageId = this.page?.homePageParent ?? localStorage.getItem('homeId') ?? null;
      const menuId = this.page?.menuId ?? localStorage.getItem('menuId') ?? null;
      this.mediaService.sendVideoTracking({
        mediaId: media?.id ?? null,
        mediaTitle: media?.title ?? null,
        pageId,
        homePageId,
        menuId,
        pageUrl: window.location.href,
        isHomepage: false,
        playTimestamp,
        durationWatched: checkpoints.size,
      });
    };

    player.addEventListener('pause', send);
    player.addEventListener('ended', send);
  }

  loadFullMedia(media, thePLayer?, currentTime?) {
    this.subs.add(this.mediaService.getCDNImage(media.url, this.iTk).subscribe({
      next: (binarie: any) => {
        if (this.destroyed) {
          return;
        }
        if (binarie && !binarie.error) {

          let file = toDataURL(binarie);

          if (file) {

            file.then((data: any) => {
              if (this.destroyed) {
                return;
              }

              const blob = convertBase64ToBlob(data.result);
              const blobUrl = URL.createObjectURL(blob);

              function convertBase64ToBlob(base64Image: string) {
                const parts = base64Image.split(';base64,');
                const imageType = parts[0].split(':')[1];
                const decodedData = window.atob(parts[1]);
                // so deus sabe pq tava quebrando quando baixa esse mimetype
                const uInt8Array = new Uint8Array(imageType === 'application/vnd.ms-excel.sheet.macroenabled.12' ? decodedData.length - 1 : decodedData.length);

                for (let i = 0; i < decodedData.length; ++i) {
                  uInt8Array[i] = decodedData.charCodeAt(i);
                };

                return new Blob([uInt8Array], { type: imageType });
              };

              this.start = true;
              this.loading = false;
              this.src = blobUrl;
              this.update.emit(true);

              const applySourceAndPlay = (player: HTMLMediaElement | null) => {
                if (!player) {
                  return;
                }

                if (player instanceof HTMLVideoElement) {
                  player.setAttribute('playsinline', '');
                  player.setAttribute('webkit-playsinline', '');
                  player.playsInline = true;
                }

                if (player.src !== blobUrl) {
                  player.src = blobUrl;
                  try { player.load(); } catch (_) { }
                }

                if (!this.autoStart) {
                  this.playMediaElement(player, currentTime);
                } else if (currentTime) {
                  player.currentTime = currentTime;
                }
              };

              if (thePLayer) {
                applySourceAndPlay(thePLayer);
              } else {
                setTimeout(() => {
                  if (this.destroyed) {
                    return;
                  }
                  applySourceAndPlay(this.getPlayerElement(this.mediaType, media));
                });
              }
            });
          } else {
            this.loading = false;
          }
        } else if (binarie && binarie.error) {
          this.error = true;
          this.loading = false;
          let error = binarie.error
          if (error.status == '404') {
            console.log('mídia não encontrada', media.url)
          }
        }
      },
      error: (err) => {
        this.loading = false;
        console.log({ 'mediaShowError': err });
      }
    }));
  }

  /** Para áudio/vídeo ao sair da view — elemento detached segue tocando no browser. */
  private stopPlayback(): void {
    this.mseDispose?.();
    this.mseDispose = null;

    const root = this.elementRef?.nativeElement as HTMLElement | undefined;
    root?.querySelectorAll?.('video, audio')?.forEach((el: HTMLMediaElement) => {
      try {
        el.pause();
        el.removeAttribute('src');
        el.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        el.load();
      } catch (_) { /* ignore */ }
    });

    if (this.src && String(this.src).startsWith('blob:')) {
      try {
        URL.revokeObjectURL(this.src);
      } catch (_) { /* ignore */ }
    }
    this.src = '';
    this.start = false;
  }
}
